import React, { useState } from 'react'
import '../../css/growthWheel.scss'
import { useGetGrowthWheelByRoleIdQuery, useGetGrowthWheelWithEvaluationsByUserIdQuery } from '../../redux/growth-wheel.endpoints'
import { User } from '../../types/User'
import GrowthWheelDashboard from '../GrowthWheelDashboard/GrowthWheelDashboard'
import { CompetencyArea } from '../../types/GrowthWheel'
import GrowthWhellCompetencyAreaView from '../GrowthWheelCompetencyAreaView/GrowthWhellCompetencyAreaView'

const GrowthWheel = ({ user }: { user: User }) => {
  const roleId = user.guildId;
  const [currentCompetencyArea, setCurrentCompetencyArea] = useState<CompetencyArea | null>(null);

  const handleClickAreaChange = (competencyArea: CompetencyArea | null) => {
    setCurrentCompetencyArea(competencyArea)
  }

  const { data: growthWheelData, isLoading } = useGetGrowthWheelByRoleIdQuery({ roleId: roleId })
  const { data: userCompetencyAreasData } = useGetGrowthWheelWithEvaluationsByUserIdQuery({ userId: user.id })

  return (
    <>
      {!currentCompetencyArea && growthWheelData &&
        <GrowthWheelDashboard
          userCompetencyAreasData={userCompetencyAreasData ?? []}
          handleClickCompetencyArea={handleClickAreaChange}
          growthWheelData={growthWheelData}
          isLoading={isLoading}
        />}
      {currentCompetencyArea &&
        <GrowthWhellCompetencyAreaView
          userCompetencyAreasList={userCompetencyAreasData ?? []}
          currentCompetencyArea={currentCompetencyArea}
          handleClickAreaChange={handleClickAreaChange}
        />}
    </>
  )
}

export default GrowthWheel